/* Tira de producto: las dos flechas de escritorio.
 *
 * El arrastre y el anclaje son del navegador (scroll-snap), así que aquí solo
 * vive lo que el CSS no puede: avanzar una tarjeta y apagar la flecha cuando
 * ya no hay a dónde ir.
 */
(function () {
  'use strict';

  function montar(seccion) {
    if (seccion.dataset.amTiraBound) return;
    seccion.dataset.amTiraBound = '1';

    var tira = seccion.querySelector('[data-am-tira-strip]');
    var flechas = seccion.querySelectorAll('[data-am-tira-ir]');
    if (!tira || !flechas.length) return;

    function paso() {
      var carta = tira.querySelector('.am-tira__card');
      if (!carta) return tira.clientWidth;
      var hueco = parseFloat(getComputedStyle(tira).columnGap || '0') || 0;
      return carta.getBoundingClientRect().width + hueco;
    }

    function repintar() {
      var fin = tira.scrollWidth - tira.clientWidth - 2;
      [].forEach.call(flechas, function (b) {
        var haciaAtras = b.dataset.amTiraIr === 'prev';
        b.disabled = haciaAtras ? tira.scrollLeft <= 2 : tira.scrollLeft >= fin;
      });
    }

    [].forEach.call(flechas, function (b) {
      b.addEventListener('click', function () {
        var signo = b.dataset.amTiraIr === 'prev' ? -1 : 1;
        tira.scrollBy({ left: signo * paso(), behavior: 'smooth' });
      });
    });

    tira.addEventListener('scroll', repintar, { passive: true });
    window.addEventListener('resize', repintar);
    repintar();
  }

  function todas() {
    [].forEach.call(document.querySelectorAll('[data-am-tira]'), montar);
  }

  todas();
  // El editor de temas vuelve a pintar la sección al guardar.
  document.addEventListener('shopify:section:load', todas);
})();
